import { GameSizeMetrics } from 'src/games/common/phaser/game/scenes/scaled-base-scene';

type GameLayoutConfig = {
  boardWidth: number;
  boardHeight: number;
  hMargin: number;
  vMargin: number;
  cellBorder: number;
  controlsMargin: number;
  controlsHeight: number;
};

export class GameMetricsService {
  public readonly gameLayoutConfig: GameLayoutConfig = {
    boardWidth: 1024,
    boardHeight: 1024,
    hMargin: 80,
    vMargin: 8 + 80 + 12,
    cellBorder: 12,
    controlsMargin: 8,
    controlsHeight: 80,
  };

  public calculateBoardScaling(gameSizeMetrics: GameSizeMetrics): {
    scaledOffsetX: number;
    scaleFactor: number;
  } {
    const layoutConfig = this.gameLayoutConfig;
    const totalWidth = layoutConfig.boardWidth + layoutConfig.hMargin * 2;
    const totalHeight =
      layoutConfig.boardHeight + layoutConfig.boardHeight / 3 + layoutConfig.vMargin;

    const scaleFactorW = gameSizeMetrics.widthDpr / totalWidth;
    const scaleFactorH = gameSizeMetrics.heightDpr / totalHeight;

    let scaledOffsetX = 0;
    if (scaleFactorH < scaleFactorW) {
      scaledOffsetX = (totalWidth * scaleFactorW - totalWidth * scaleFactorH) * 0.5;
    }

    return {
      scaledOffsetX: scaledOffsetX,
      scaleFactor: Math.min(scaleFactorW, scaleFactorH),
    };
  }
}
